import produce from 'immer';
import { types } from './types';
import { IAffiliateState } from './types';

const initialState: IAffiliateState = {
    affiliates: [],
    totalCount: 0,
    pageSize: 20,
    currentPage: 1,
    totalPages: 0,
    loading: false,
    error: null,
    createLoading: false,
    deleteLoading: false,
};

const reducer = (state: IAffiliateState = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case types.CREATE_AFFILIATE:
            return produce(state, draftState => {
                draftState.createLoading = true;
                draftState.error = null;
            });

        case types.CREATE_AFFILIATE_SUCCESS:
            return produce(state, draftState => {
                draftState.createLoading = false;
                draftState.affiliates.unshift(payload);
                draftState.totalCount += 1;
            });

        case types.CREATE_AFFILIATE_FAILED:
            return produce(state, draftState => {
                draftState.createLoading = false;
                draftState.error = payload;
            });

        case types.GET_AFFILIATES:
            return produce(state, draftState => {
                draftState.loading = true;
                draftState.error = null;
            });

        case types.GET_AFFILIATES_SUCCESS:
            return produce(state, draftState => {
                draftState.loading = false;
                draftState.affiliates = payload.data.data;
                draftState.totalCount = payload.totalCount;
                draftState.pageSize = payload.pageSize;
                draftState.currentPage = payload.currentPage;
                draftState.totalPages = payload.totalPages;
            });

        case types.GET_AFFILIATES_FAILED:
            return produce(state, draftState => {
                draftState.loading = false;
                draftState.error = payload;
            });

        case types.DELETE_AFFILIATE:
            return produce(state, draftState => {
                draftState.deleteLoading = true;
                draftState.error = null;
            });

        case types.DELETE_AFFILIATE_SUCCESS:
            return produce(state, draftState => {
                draftState.deleteLoading = false;
                draftState.affiliates = draftState.affiliates.filter(affiliate => affiliate._id !== payload);
                draftState.totalCount -= 1;
            });

        case types.DELETE_AFFILIATE_FAILED:
            return produce(state, draftState => {
                draftState.deleteLoading = false;
                draftState.error = payload;
            });

        default:
            return state;
    }
};

export { reducer };
